import { OrganisationIdAndName } from '@/types/organisation';
import { useSelectOptions } from './use-select-options';

export const useOrganisationSelectOptions = (
  organisations: OrganisationIdAndName[],
) =>
  useSelectOptions<number, OrganisationIdAndName, 'name', 'id'>(
    organisations,
    'name',
    'id',
  );
